<template>
  <div class="e-questions">
    <div class="e-block-wrap">
      <div class="e-block">
        <div class="e-block__scroll" :style="{ minHeight: containerHeight }">
          <FlowSelector title="Products"
                        :items="flowItems" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FlowSelector from '@/components/FlowSelector.vue';

export default {
  components: {
    FlowSelector,
  },
  name: 'Products',
  data() {
    return {
      flowItems: [
        { title: 'Sizing & selecting', link: 'help-me-choose', class: 'sizing' },
        { title: 'UNIT Operation', link: 'unit', class: 'unit' },
        { title: 'installation & Maintenance', link: 'installation', class: 'installation' },
        { title: 'Parts', link: 'parts', class: 'parts' },
        { title: 'International<br/>products', link: 'international', class: 'international' },
      ],
    };
  },
  mounted() {
    this.resetAll();
    const currentItem = { name: 'Products', href: '/' };
    if (!this.initBreadcrumbs.find((step) => step.name === currentItem.name)) {
      this.addBreadcrumbs(currentItem);
    }
  },
  computed: {
    ...mapState(['selectedFlow', 'steps', 'initBreadcrumbs', 'containerHeight']),
  },
  methods: {
    ...mapActions(['addBreadcrumbs', 'resetAll']),
  },
};
</script>

<style lang="scss">

</style>
